export default __webpack_public_path__ + "static/media/gallery35.25181146.webp";